<span class="text-navy-90 font-bold mb-2">{{ buildTranslationKey('header') | translate }}</span>

<div
  class="toggle-container flex items-center gap-x-3 cursor-pointer"
  role="button"
  (click)="updateAutomaticApprovalsFlag(!hasAutomaticApprovals)">
  <app-toggle
    class="toggle"
    [ngModel]="hasAutomaticApprovals"
    (ngModelChange)="updateAutomaticApprovalsFlag($event)">
  </app-toggle>

  <span class="text-navy-70 text-base">{{ buildTranslationKey('label') | translate }}</span>
</div>

<span class="text-navy-70 whitespace-pre">{{ buildTranslationKey('description') | translate }}</span>
